import { AnalyticsEvent } from "./events";
export const gtmDestinationEvents = {
    [AnalyticsEvent.RegistrationCompleted]: true,
    [AnalyticsEvent.FirstOrderPlaced]: true,
    [AnalyticsEvent.PlanStarted]: true,
    [AnalyticsEvent.ProductViewed]: true,
    [AnalyticsEvent.ProductAddedToCart]: true,
    [AnalyticsEvent.CheckoutProcessStarted]: true,
    [AnalyticsEvent.CheckoutProcessCompleted]: true,
    [AnalyticsEvent.ProductsSearched]: true,
    [AnalyticsEvent.ElementClicked]: true,
    [AnalyticsEvent.CartViewed]: true,
    [AnalyticsEvent.FirstPurchased]: true,
    [AnalyticsEvent.LoginCompleted]: true,
    "Loaded a Page": true,
};
export const pciQueueDestinationEvents = {
    [AnalyticsEvent.FirstOrderPlaced]: true,
    [AnalyticsEvent.PlanStarted]: true,
    [AnalyticsEvent.CheckoutProcessCompleted]: true,
    [AnalyticsEvent.FirstPurchased]: true,
};
